import { create } from 'zustand';
import { apiClient } from '../services/api';

const useRestaurantStore = create((set, get) => ({
  restaurants: [],
  loading: false,
  error: null,

  fetchRestaurants: async () => {
    set({ loading: true, error: null });
    try {
      const data = await apiClient.get('/api/v1/restaurants');
      set({ restaurants: data, loading: false });
    } catch (error) {
      console.error('Error fetching restaurants:', error);
      set({ error: error.message, loading: false });
    }
  },

  createRestaurant: async (restaurantData) => {
    set({ loading: true, error: null });
    try {
      const data = await apiClient.post('/api/v1/restaurants', restaurantData);
      set(state => ({ 
        restaurants: [...state.restaurants, data],
        loading: false
      }));
      return data;
    } catch (error) {
      console.error('Error creating restaurant:', error);
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  updateRestaurant: async (restaurantId, restaurantData) => {
    set({ loading: true, error: null });
    try {
      const data = await apiClient.put(`/api/v1/restaurants/${restaurantId}`, restaurantData);
      set(state => ({
        restaurants: state.restaurants.map(restaurant => 
          restaurant.id === restaurantId ? data : restaurant
        ),
        loading: false
      }));
      return data;
    } catch (error) {
      console.error('Error updating restaurant:', error);
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  deleteRestaurant: async (restaurantId) => {
    set({ loading: true, error: null });
    try {
      await apiClient.delete(`/api/v1/restaurants/${restaurantId}`);
      set(state => ({
        restaurants: state.restaurants.filter(restaurant => restaurant.id !== restaurantId),
        loading: false
      }));
      return { success: true };
    } catch (error) {
      console.error('Error deleting restaurant:', error);
      set({ error: error.message, loading: false });
      throw error;
    }
  }
}));

export default useRestaurantStore;